import { Component } from '@angular/core';

@Component({
  selector: 'benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.scss']
})
export class BenefitsComponent {
  list = [
    {
      title: $localize`Expose Your Culinary Creations`,
      subtitle: $localize`Showcase your menu to a vast audience of food lovers. With Akl Bayti, your dishes do the talking, attracting customers craving homemade, authentic meals.`,
      image: 'assets/merchant-landing-page/svg/benefits-image-1.svg'
    },
    {
      title: $localize`Simplify Business Operations`,
      subtitle: $localize`Streamline your workflow with integrated online payments and automated order management. Spend less time on paperwork and more time creating culinary masterpieces.`,
      image: 'assets/merchant-landing-page/svg/benefits-image-2.svg'
    },
    {
      title: $localize`Exclusive Deals on Kitchen Essentials`,
      subtitle: $localize`Enjoy access to wholesale prices on high-quality ingredients, kitchen tools, and cooking materials. Lower your costs without compromising on quality.`,
      image: 'assets/merchant-landing-page/svg/benefits-image-3.svg'
    },
    {
      title: $localize`Delivery Services`,
      subtitle: $localize`Focus on cooking; we\'ll handle the delivery. Our partnership with leading delivery services ensures your food reaches customers fresh and fast.`,
      image: 'assets/merchant-landing-page/svg/benefits-image-4.svg'
    },
    {
      title: $localize`Expand Your Reach`,
      subtitle: $localize`Our marketing efforts put your kitchen on the map. Benefit from increased exposure through our social media channels, email marketing, and featured listings.`,
      image: 'assets/merchant-landing-page/svg/benefits-image-5.svg'
    },
  ]

}


